import { useQuery } from '@tanstack/react-query';
import accesosService from '../services/accesosService';
import { accesosKeys } from '../queryKeys';

// GET /accesos. Devuelve el array de usuarios (activos e inactivos). El
// componente decide si filtra por activo === true. Normaliza la respuesta a un
// array para que la tabla nunca reciba undefined.
const useAccesosLista = (headquarter) => {
  return useQuery({
    queryKey: accesosKeys.lista(headquarter),
    queryFn: async () => {
      const res = await accesosService.listarAccesos({ headquarter });
      return Array.isArray(res?.data) ? res.data : [];
    },
    enabled: Boolean(headquarter),
    staleTime: 30 * 1000,
  });
};

export default useAccesosLista;
